import {SubscriberEngagementRecapStatsType} from './types';

export const SUBSCRIBER_ENGAGEMENT_RECAP_VISIBILITY_KEY = 'subscriber-engagement-recap-visibility';
export const SUBSCRIBER_ENGAGEMENT_RECAP_CONFETTI_SEEN_KEY =
    'subscriber-engagement-recap-confetti-seen';

export const MIN_STATS_THRESHOLD = 4;

/** Minimum value per metric; at least one must pass `>=` to show the recap. */
export const minThresholdMap: Record<SubscriberEngagementRecapStatsType, number> = {
    [SubscriberEngagementRecapStatsType.CertificationCount]: 1,
    [SubscriberEngagementRecapStatsType.CoursesCompletedCount]: 1,
    [SubscriberEngagementRecapStatsType.CoursesEnrolledCount]: 2,
    [SubscriberEngagementRecapStatsType.LongestWeeklyStreak]: 2,
    [SubscriberEngagementRecapStatsType.LearningDaysCount]: 7,
    [SubscriberEngagementRecapStatsType.MinutesWatched]: 60,
    [SubscriberEngagementRecapStatsType.TopicsExplored]: 2,
};
